import { urlEscaped } from '@app/utils/urlEscaped'

import { createApiAction } from '@app/packages/api/utils'
import type { ApiIgnoredUser } from '@app/packages/api/v2/types/entities'
import { v2Path } from '@app/packages/api/v2/utils'

export const getIgnoredUsers = (query: { page: number; per_page?: number }) =>
  createApiAction('getIgnoredUsers', dispatch =>
    dispatch<{ data: ApiIgnoredUser[]; meta: { current_page: number; total_pages: number; total: number } }>({
      method: 'GET',
      endpoint: v2Path('/api/v2/ignored_users', query),
    })
  )

export const getIgnoredUsersById = (userId: string) =>
  createApiAction('getIgnoredUsersById', dispatch =>
    dispatch<{ data: ApiIgnoredUser }>({ method: 'GET', endpoint: urlEscaped`/api/v2/ignored_users/${userId}` })
  )

export const postIgnoredUsers = (user_id: string) =>
  createApiAction('postIgnoredUsers', dispatch => dispatch<unknown>({ method: 'POST', endpoint: '/api/v2/ignored_users', body: JSON.stringify({ user_id }) }))

export const deleteIgnoredUsersById = (userId: string) =>
  createApiAction('deleteIgnoredUsersById', dispatch => dispatch<unknown>({ method: 'DELETE', endpoint: urlEscaped`/api/v2/ignored_users/${userId}` }))
